import { render } from "./ACol.vue?vue&type=template&id=1750cf47"
import script from "./ACol.vue?vue&type=script&lang=js"
export * from "./ACol.vue?vue&type=script&lang=js"

import "./ACol.vue?vue&type=style&index=0&id=1750cf47&lang=scss"

import exportComponent from "/home/runner/work/eoy-2022-frontend/eoy-2022-frontend/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__